import type { MacrosComponentProps } from './MacrosComponent';

export const MacrosComponent = {
    MountAsync: async (target: HTMLElement, props: MacrosComponentProps) => {
        // Path to mountReactComponentAsync assumes 'Macros' is three levels deep from 'ReservationsApp/js/'
        // (js -> Sales -> Macros)
        // Adjust if mountReactComponentAsync is located elsewhere or if the folder structure differs.
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync'); 
        const { MacrosComponent } = await import('./MacrosComponent');
        return await mountReactComponentAsync(target, MacrosComponent, props);
    }
};